/* eslint-disable no-unused-vars */
const config = {}
export default config



// WEBPACK FOOTER //
// ./src/router/config.js